import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

import { Modal } from 'antd';
import { EnvelopeSimple } from 'phosphor-react';
import { useTranslation } from 'react-i18next';

import { FullNameInputComp } from './CountryCodeDropdown';
import LoadingButton from './LoadingButton';
import SecSeperator from './SecSeperator';

import { $FIXME, ROUTES } from '../../constants';
import {
    defaultDailing_Code,
    getCountryByCode
} from '../../helpers/countryCode';
import { getNumbersOnly } from '../../helpers/functions';
import { IBuyCar, request } from '../../helpers/request';
import { ICombineReducerType } from '../../redux/reducers';
import {
    emailValidate,
    fullNameValidate
} from '../../utils/Helper/jsHelpers';
import { setFullNameError } from '../Certification';
import PhoneNumberInput from './PhoneNumberInput';

interface IBuyCarConfirm {
    open: boolean;
    setModalOpen: (open: boolean) => void;
    carId: string;
}

const BuyCarConfirm = (props: IBuyCarConfirm) => {
    const { open, setModalOpen, carId } = props;
    const { t } = useTranslation();
    const [isvisiable, setVisiable] = useState(false);
    const [error, setError] = useState<any>({});
    const [disabled, setDisabled] = useState(true);
    let { user } = useSelector((state: ICombineReducerType) => state.auth);
    const [userData, setUserData] = useState({
        phoneNumber: {
            code: user?.phoneNumber?.code
                ? String(user?.phoneNumber?.code)
                : defaultDailing_Code,
            number: user?.phoneNumber?.number
                ? getNumbersOnly(`${user?.phoneNumber?.number}`)
                : ''
        },
        fullName: user?.name ?? '',
        email: user?.email ?? ''
    });
    const [loading, setLoading] = useState(false);
    const [phoneValidErr, setPhoneValidErr] = useState({
        number: true
    });

    const navigate = useNavigate();
    useEffect(() => {
        setUserData({
            phoneNumber: {
                code: user?.phoneNumber?.code ?? defaultDailing_Code,
                number: user?.phoneNumber?.number ?? ''
            },
            fullName: user?.name ?? '',
            email: user?.email ?? ''
        });
        setError({});
    }, [open]);

    useEffect(() => {
        if (userData.fullName) {
            if (fullNameValidate(userData.fullName)) {
                setError({});
            }
        }
    }, [userData.fullName]);

    useEffect(() => {
        if (
            !userData.fullName &&
            !userData.phoneNumber.number &&
            !userData.email
        ) {
            setError({});
        }
        if (
            fullNameValidate(userData.fullName) &&
            !phoneValidErr?.number &&
            emailValidate(userData.email)
        ) {
            setDisabled(false);
        } else {
            setDisabled(true);
        }
    }, [userData, phoneValidErr]);

    const setEmailError = function (
        email: $FIXME,
        setErrors: $FIXME,
        t: $FIXME
    ) {
        if (!emailValidate(email)) {
            setErrors({
                email: t('pleaseInputValidEmail')
            });
        }
    };

    async function submit(e: any) {
        e.preventDefault();
        setLoading(true);
        try {
            let {
                fullName,
                phoneNumber: { code, number },
                email
            } = userData;
            let requestData: IBuyCar = {
                fullName,
                code,
                number: String(getNumbersOnly(number)),
                email,
                car: carId
            };
            await request.sendBuyCarInfo(requestData);
            setModalOpen(false);
            setVisiable(true);
        } catch (err: any) {
        } finally {
            setLoading(false);
        }
    }

    const closeModal = () => {
        setModalOpen(false);
        setLoading(false);
    };

    const goToHome = () => {
        navigate(t(ROUTES.home, { ns: 'routes' }));
        setVisiable(false);
    };

    const SuccessModal = () => {
        return (
            <Modal
                className="save-changes-modal ants-modal"
                title={t('Detailssentsuccessfully')}
                open={isvisiable}
                onCancel={() => setVisiable(false)}
                closable={true}
                centered={true}
            >
                <p className="subtitle">{t('DetailChangeSubtitle')}</p>
                <div className="done-icon">
                    <img src="/images/done.webp" alt="done" />
                </div>
                <div className="get-call-back">
                    <button className="back-to-home" onClick={() => goToHome()}>
                        {t('backToHome')}
                    </button>
                </div>
            </Modal>
        );
    };

    return (
        <>
            <Modal
                className="callback-modal ants-modal "
                open={open}
                closable={true}
                onCancel={closeModal}
            >
                <SecSeperator className="modal-sec-seperator" />
                <div className="getacallback-header">
                    {t('provideUsYourDetails')}
                </div>
                <span className="subtitle">{t('callBackSubtitle')}</span>
                <form onSubmit={submit}>
                    <div className=" phone-input overflow  relative  ">
                        <label
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}
                        >
                            <EnvelopeSimple size={24} color="#727272" />
                        </label>
                        <input
                            onBlur={() => {
                                if (userData.email) {
                                    setEmailError(userData.email, setError, t);
                                }
                            }}
                            type="text"
                            placeholder={t('enteremailAddress')}
                            onChange={(e: $FIXME) => {
                                setUserData({
                                    ...userData,
                                    [e.target.name]: e.target.value
                                });
                            }}
                            name="email"
                            value={userData.email}
                            required
                            autoComplete="off"
                            disabled={user?.email ? true : false}
                        />
                        {error.email && (
                            <div
                                className="error-label absolute fade-in "
                                style={{ bottom: '-25px', left: 0 }}
                            >
                                {t(error.email)}
                            </div>
                        )}
                    </div>
                    <FullNameInputComp
                        setFullNameError={() => {
                            if (userData.fullName) {
                                setFullNameError(
                                    userData.fullName,
                                    setError,
                                    t
                                );
                            }
                        }}
                        handleChange={(e: $FIXME) => {
                            setUserData({
                                ...userData,
                                [e.target.name]: e.target.value
                            });
                        }}
                        value={userData.fullName}
                        t={t}
                        err={error.fullName}
                    />
                    <div className="phone-number">
                        <PhoneNumberInput
                            onChange={(value: any, key: string) => {
                                setUserData((prev) => ({
                                    ...prev,
                                    phoneNumber: {
                                        ...prev.phoneNumber,
                                        [key]: value[key],
                                        code: value?.code
                                    }
                                }));
                            }}
                            name="number"
                            value={getNumbersOnly(
                                `${userData?.phoneNumber?.number}`
                            )}
                            defaultSelect={
                                userData?.phoneNumber?.code
                                    ? getCountryByCode(
                                          userData?.phoneNumber?.code
                                      )
                                    : getCountryByCode(defaultDailing_Code)
                            }
                            setError={setPhoneValidErr}
                        />
                    </div>
                    <div className="cert-submit callback-footer">
                        <span>
                            {t('byClickingXButton', {
                                name: t('send')
                            })}{' '}
                            <Link
                                to={t('/terms-of-use', { ns: 'routes' })}
                                className="termandpolicy"
                            >
                                {t('termOfUse')}
                            </Link>{' '}
                            {t('and')}{' '}
                            <Link
                                to={t('/privacy-policy', { ns: 'routes' })}
                                className="termandpolicy"
                            >
                                {t('privacyPolicy')}
                            </Link>
                        </span>
                        {loading ? (
                            <LoadingButton buttonText="sending" />
                        ) : (
                            <button
                                className="bottom-btn text-uppercase"
                                disabled={disabled}
                                type="submit"
                            >
                                {t('send')}
                            </button>
                        )}
                    </div>
                </form>
            </Modal>
            <SuccessModal />
        </>
    );
};
export default BuyCarConfirm;
